import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { MuiDialog, MuiBox, MuiTypography } from 'theme/material-ui';
import { Slide } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import { FontSize } from 'modules/styles/variables';
import { MarginMuiBox } from '../styled';
import { Color } from 'modules/styles/colors';
import { LOCATION_STATES } from 'modules/constants/LocationStates';
import StyledButton from 'components/UI/Button/StyledButton';
import { PaymentFormField } from '../types';
import { PaymentForm } from 'store/preRegistration/payment/types';
import Spacer from 'components/UI/Layout/Spacer';
import { InputField } from 'components/UI/Input/TextInput';
import SelectField from 'components/PreRegister/FormFields/SelectField';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { convertToLowerKabobCase } from 'modules/utils/StringUtils';
import { PreRegHeader } from '../common';
import { ACH_ACCOUNT_TYPES } from './FormConstant';
import { StyledAsterisk } from 'components/RequiredFieldsLegend';

type Props = {
  closePopup: Function;
  formField: PaymentFormField;
  values: PaymentForm;
  setFieldValue: any;
};

const Transition = React.forwardRef<unknown, TransitionProps>((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

export const ACHModel = (props: Props) => {
  const {
    closePopup,
    formField: {
      firstName,
      lastName,
      routingNumber,
      accountNumber,
      address1,
      address2,
      city,
      state,
      zipCode
    },
    values,
    setFieldValue
  } = props;
  const [open, setOpen] = React.useState(false);

  useEffect(() => setOpen(true), []);

  const handleClose = () => {
    setOpen(false);
    closePopup(false);
  };

  return (
    <MuiDialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
      <MuiBox flexDirection="column" alignContent="center">
        <PreRegHeader title="Payment Method" handleClose={handleClose} />

        <MarginMuiBox>
          <MuiTypography>
            Required fields are marked with an asterisk <StyledAsterisk />
          </MuiTypography>
        </MarginMuiBox>
        <MuiBox ml={2} alignItems="center">
          <FormControl component="fieldset">
            <RadioGroup
              row
              value={values.accountType}
              onChange={e => {
                const { value } = e.target;
                setFieldValue('accountType', value);
              }}
            >
              {ACH_ACCOUNT_TYPES.map(status => (
                <FormControlLabel
                  key={`ACH-account-type-${status.value}`}
                  value={status.value}
                  control={<Radio color="primary" />}
                  label={status.label}
                  data-testid={convertToLowerKabobCase(status.label, '-account-type')}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </MuiBox>
        <MarginMuiBox pt={1} flexDirection="column">
          <MuiTypography fontSize={FontSize.medium}>
            First Name <StyledAsterisk />
          </MuiTypography>
          <InputField name={firstName.name} label={firstName.label} fullWidth />
          <Spacer size="small" />
          <MuiTypography fontSize={FontSize.medium}>
            Last Name <StyledAsterisk />
          </MuiTypography>
          <InputField name={lastName.name} label={lastName.label} fullWidth />
          <Spacer size="small" />
          <MuiTypography fontSize={FontSize.medium}>
            Routing Number <StyledAsterisk />
          </MuiTypography>
          <InputField name={routingNumber.name} label={routingNumber.label} fullWidth />
          <Spacer size="small" />
          <MuiTypography fontSize={FontSize.medium}>
            Account Number <StyledAsterisk />
          </MuiTypography>
          <InputField name={accountNumber.name} label={accountNumber.label} fullWidth />
          <Spacer size="small" />
          <MuiTypography fontSize={FontSize.medium}>
            Billing Address <StyledAsterisk />
          </MuiTypography>
          <InputField name={address1.name} label={address1.label} fullWidth />
          <Spacer size="small" />
          <MuiTypography fontSize={FontSize.medium}>Billing Address Line 2</MuiTypography>
          <InputField name={address2.name} label={address2.label} fullWidth />
          <Spacer size="small" />
          <MuiTypography fontSize={FontSize.medium}>
            City <StyledAsterisk />
          </MuiTypography>
          <InputField name={city.name} label={city.label} fullWidth />
          <Spacer size="small" />
          <MuiTypography fontSize={FontSize.medium}>
            State <StyledAsterisk />
          </MuiTypography>
          <SelectField name={state.name} label={state.label} data={LOCATION_STATES} fullWidth />
          <Spacer size="small" />
          <MuiTypography fontSize={FontSize.medium}>
            Zip Code <StyledAsterisk />
          </MuiTypography>
          <InputField name={zipCode.name} label={zipCode.label} fullWidth />
        </MarginMuiBox>
      </MuiBox>
      <MuiBox m={1} p={1} flexDirection="row">
        <StyledButton onPress={handleClose}>Confirm</StyledButton>
      </MuiBox>
    </MuiDialog>
  );
};

ACHModel.defaultProps = {
  closePopup: () => {}
};

export default connect()(ACHModel);
